import React from 'react';
import { FaMapMarkerAlt } from "react-icons/fa";

const LocationMarker = ({onClick }) => {
    let iconStyles = { color: "red", fontSize: "2.5em" };
    return (
        <div onClick={onClick}>
            <FaMapMarkerAlt style={iconStyles}/>
        </div>
    )
}

export default LocationMarker